import { z } from "zod";

export const paymentScheme = z.object({
  amount: z.string().min(1, 'Обов\'язкове поле'),
  paymentMethod: z.string().min(1, 'Обов\'язкове поле'),
});

export type PaymentFormScheme = z.infer<typeof paymentScheme>;

export const deleteSchema = z.object({
  password: z.string().min(1, 'Обов\'язкове поле'),
});

export type DeleteFormScheme = z.infer<typeof deleteSchema>;
